import { createFileRoute } from '@tanstack/react-router'

import { CredentialGroupsPage } from '#/modules/loadboards/credential-groups-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/group-loadboard')({
  component: function GroupLoadboardRoute() {
    // A tenant's own Super Dispatch account, shared with other tenants.
    return <CredentialGroupsPage isPlatform={false} title="Group Loadboard" />
  },
  validateSearch: validateListSearch,
})
